import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService {
  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (localStorage.getItem('token')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
    }
    // set system lang
    const lang = localStorage.getItem('lang');
    request = request.clone({
      setHeaders: {
        'Accept-Language': lang == null ? 'ar' : lang,
      },
    }); 
    
    return next.handle(request).pipe(
      catchError((err: any, caught: Observable<HttpEvent<any>>) => {
          throw err;
      })
  );
  }
}
